import React from 'react'
import PropTypes from 'prop-types'
import TimePickerRaw from '~/components/common/TimePicker'

const TimePicker = ({ field, form, disabled, ...props }) => (
  <TimePickerRaw
    startTime={field.value}
    disabled={disabled || !!form.values.__readOnly}
    {...field}
    {...props}
  />
)

TimePicker.defaultProps = {
  disabled: false,
}

TimePicker.propTypes = {
  form: PropTypes.shape().isRequired,
  field: PropTypes.shape().isRequired,
  disabled: PropTypes.bool,
}

export default TimePicker
